import React from "react";
import styled, { keyframes } from "styled-components";
import SmallLogo from "../../SVGs/SamllLogo.svg";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const CustomLoader = () => (
  <LoaderContainer>
    <Logo src={SmallLogo} alt="Loading..." />
  </LoaderContainer>
);

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Logo = styled.img`
  width: 100px;
  height: 100px;
  animation: ${spin} 1s linear infinite;
`;

export default CustomLoader;
